import AvgSpeedToLeadIcon from '@forwardflow/assets/svg/AvgSpeedToLeadIcon1'
import CallsAppointmentIcon from '@forwardflow/assets/svg/CallsAppointmentIcon'
import { useGetDashboardCommunication } from '@forwardflow/hooks/customHooks'
import { AgentType, TimePeriod } from '@forwardflow/types'
import Icon from '@forwardflow/ui/Icons'
import { useSearchParams } from 'react-router-dom'

export const CommunicationStatsSummary = () => {
   const [searchParams] = useSearchParams()
   const timePeriod = searchParams.get('timePeriod') || 'allTime'
   const agentType = searchParams.get('agentType') || 'all'
   const { data: DashboardChartsLeadSource } = useGetDashboardCommunication({
      timePeriod: timePeriod as TimePeriod,
      agentType: agentType as AgentType,
   })
   return (
      <div className="flex flex-col w-full gap-4 xl:flex-row">
         <div className="bg-white/5 rounded-lg p-6 flex items-center gap-6 flex-1 min-w-[220px]">
            <Icon
               name="VoiceMail"
               width={32}
               height={32}
               className="w-8 h-8 scale-[1.6] fill-white flexc"
            />
            <div>
               <div className="text-2xl font-semibold text-white">
                  {DashboardChartsLeadSource?.OtherStats?.voicemailsDropped ??
                     '--'}
               </div>
               <div className="font-medium">Voicemails dropped</div>
            </div>
         </div>
         <div className="bg-white/5 rounded-lg p-6 flex items-center gap-6 flex-1 min-w-[220px]">
            <CallsAppointmentIcon />
            <div>
               <div className="text-2xl font-semibold text-white">
                  {DashboardChartsLeadSource?.OtherStats?.callsPerAppointment ??
                     '--'}
               </div>
               <div className="font-medium">Calls / Appointment</div>
            </div>
         </div>
         <div className="bg-white/5 rounded-lg p-6 flex items-center gap-4 flex-1 min-w-[220px]">
            <AvgSpeedToLeadIcon />
            <div>
               <div className="text-2xl font-semibold text-white">
                  {DashboardChartsLeadSource?.OtherStats?.avgSpeedToLeadHours
                     ? `${DashboardChartsLeadSource.OtherStats.avgSpeedToLeadHours} Hrs.`
                     : '--'}
               </div>
               <div className="font-medium">Avg Speed to Lead</div>
            </div>
         </div>
      </div>
   )
}
